/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.133.2-v202605041853-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqModelsApiClass {
 
   constructor() {}

  /**
   * @summary Apply a model once by providing inputs to the model's features. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public applyModel(
    body: models.ModelInitialApplicationInputV1,
    {
      modelId
    } : {
      modelId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/instances`
      .replace('{modelId}', encodeURIComponent(String(modelId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Apply a model to a table definition and recompute the newly-added columns. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} tableDefinitionId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public applyModelToTable(
    body: models.TableModelApplicationInputV1,
    {
      modelId,
      tableDefinitionId
    } : {
      modelId: string,
      tableDefinitionId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }

    if (tableDefinitionId === null || tableDefinitionId === undefined) {
      throw new Error("'tableDefinitionId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}`
      .replace('{modelId}', encodeURIComponent(String(modelId)))
      .replace('{tableDefinitionId}', encodeURIComponent(String(tableDefinitionId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ModelTableApplicationOutputV1>;
  }

  /**
   * @summary Archive a model by its ID. This endpoint is experimental and may change in future releases.
   * @param {string} id - ID of the model to archive
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public archiveModel(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a new draft from a published version. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createDraft(
    {
      modelId,
    } : {
      modelId: string,
    },
    body?: models.ModelDraftCreateInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/drafts`
      .replace('{modelId}', encodeURIComponent(String(modelId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Create a new model. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createModel(
    body: models.ModelInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Create a new model from reference items. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createModelFromItems(
    body: models.ModelFromIdsInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/from-items`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Create a new model from reference column definitions. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createModelFromTableColumnDefinitions(
    body: models.ModelFromIdsInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/from-table-column-definitions`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Diff two model versions for compatibility. This endpoint is experimental and may change in future releases.
   * @param {string} baseModelId - ID of the base model version
   * @param {string} candidateModelId - ID of the candidate model version
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public diffModels(
    {
      baseModelId,
      candidateModelId
    } : {
      baseModelId: string,
      candidateModelId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (baseModelId === null || baseModelId === undefined) {
      throw new Error("'baseModelId' parameter required");
    }

    if (candidateModelId === null || candidateModelId === undefined) {
      throw new Error("'candidateModelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(baseModelId))}/diff/${encodeURIComponent(String(candidateModelId))}`
      .replace('{baseModelId}', encodeURIComponent(String(baseModelId)))
      .replace('{candidateModelId}', encodeURIComponent(String(candidateModelId)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ModelCompatibilityReportOutputV1>;
  }

  /**
   * @summary Duplicate a model by its ID. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public duplicateModel(
    body: models.ModelDuplicateInputV1,
    {
      modelId
    } : {
      modelId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/duplicate`
      .replace('{modelId}', encodeURIComponent(String(modelId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Edit a model by ID. The full model must be provided. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public editModel(
    body: models.ModelInputV1,
    {
      modelId
    } : {
      modelId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}`
      .replace('{modelId}', encodeURIComponent(String(modelId)));



    return axiosInstance.request({
      method: 'put',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Edit a specific model version. The model must be unlocked (draft or initial). This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} versionId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public editModelVersion(
    body: models.ModelInputV1,
    {
      modelId,
      versionId
    } : {
      modelId: string,
      versionId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }

    if (versionId === null || versionId === undefined) {
      throw new Error("'versionId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/versions/${encodeURIComponent(String(versionId))}`
      .replace('{modelId}', encodeURIComponent(String(modelId)))
      .replace('{versionId}', encodeURIComponent(String(versionId)));



    return axiosInstance.request({
      method: 'put',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Generates a list of independent and dependent column definitions from a list of items. The independent column definitions do not rely on other columns, while the dependent column definitions do. This can be used to create a model table from calculations. This endpoint is experimental and may change in future releases.
   * @param {string} scopedTo - The ID of the Workbook that the formula creator column rules will be scoped to
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public generateColumnModel(
    body: models.ColumnModelInputV1,
    {
      scopedTo
    } : {
      scopedTo: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (scopedTo === null || scopedTo === undefined) {
      throw new Error("'scopedTo' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/modelData`;

    const queryParams = {
      ['scopedTo']: scopedTo
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ColumnModelOutput>;
  }

  /**
   * @summary Fetch the tables to which a model has been applied. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getAppliedModelTables(
    {
      modelId
    } : {
      modelId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/tables`
      .replace('{modelId}', encodeURIComponent(String(modelId)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<Array<models.TableDefinitionOutputV1>>;
  }

  /**
   * @summary Get the current user's draft for a model container, if one exists. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getDraft(
    {
      modelId
    } : {
      modelId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/draft`
      .replace('{modelId}', encodeURIComponent(String(modelId)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Fetch model instance by ID
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getInstance(
    {
      instanceId
    } : {
      instanceId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (instanceId === null || instanceId === undefined) {
      throw new Error("'instanceId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/instances/${encodeURIComponent(String(instanceId))}`
      .replace('{instanceId}', encodeURIComponent(String(instanceId)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Fetch model instances for model ID
   * @param {string} modelId
   * @param {number} [offset=0] - The pagination offset, the index of the first model instance that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of model instances that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getInstancesForModel(
    {
      modelId,
      offset,
      limit
    } : {
      modelId: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/instances`
      .replace('{modelId}', encodeURIComponent(String(modelId)));

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.InstanceOutputPaginatedListV1>;
  }

  /**
   * @summary Fetch model instances for table definition ID
   * @param {string} tableDefinitionId
   * @param {number} [offset=0] - The pagination offset, the index of the first model instance that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of model instances that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getInstancesForTable(
    {
      tableDefinitionId,
      offset,
      limit
    } : {
      tableDefinitionId: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableDefinitionId === null || tableDefinitionId === undefined) {
      throw new Error("'tableDefinitionId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/instances/table/${encodeURIComponent(String(tableDefinitionId))}`
      .replace('{tableDefinitionId}', encodeURIComponent(String(tableDefinitionId)));

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.InstanceOutputPaginatedListV1>;
  }

  /**
   * @summary Fetch a model by ID. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getModel(
    {
      modelId
    } : {
      modelId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}`
      .replace('{modelId}', encodeURIComponent(String(modelId)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Fetch the full model for a specific published version. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} versionId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getModelVersion(
    {
      modelId,
      versionId
    } : {
      modelId: string,
      versionId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }

    if (versionId === null || versionId === undefined) {
      throw new Error("'versionId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/versions/${encodeURIComponent(String(versionId))}`
      .replace('{modelId}', encodeURIComponent(String(modelId)))
      .replace('{versionId}', encodeURIComponent(String(versionId)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary List all published versions of a model. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {number} [offset=0] - The pagination offset, the index of the first version that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of versions that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getModelVersions(
    {
      modelId,
      offset,
      limit
    } : {
      modelId: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/versions`
      .replace('{modelId}', encodeURIComponent(String(modelId)));

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ModelVersionListOutputV1>;
  }

  /**
   * @summary Get a list of models. This endpoint is experimental and may change in future releases.
   * @param {number} [offset=0] - The pagination offset, the index of the first item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of models that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getModels(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ModelOutputListV1>;
  }

  /**
   * @summary Get existing model applications to a given table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the table definition
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getTableDefinitionModelApplications(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(id))}/model-applications`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ModelTableApplicationsOutputListV1>;
  }

  /**
   * @summary Publish a draft model as a new version. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public publishModelVersion(
    body: models.ModelPublishInputV1,
    {
      modelId
    } : {
      modelId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/versions`
      .replace('{modelId}', encodeURIComponent(String(modelId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Reapply a model once by providing inputs to the model's features. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public reapplyModel(
    body: models.ModelReapplicationInputV1,
    {
      modelId,
      instanceId
    } : {
      modelId: string,
      instanceId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }

    if (instanceId === null || instanceId === undefined) {
      throw new Error("'instanceId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/instances/${encodeURIComponent(String(instanceId))}`
      .replace('{modelId}', encodeURIComponent(String(modelId)))
      .replace('{instanceId}', encodeURIComponent(String(instanceId)));



    return axiosInstance.request({
      method: 'put',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Reapply a model to a table definition and recompute the results using the updated inputs. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} tableDefinitionId
   * @param {string} applicationId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public reapplyModelToTable(
    body: models.TableModelApplicationInputV1,
    {
      modelId,
      tableDefinitionId,
      applicationId
    } : {
      modelId: string,
      tableDefinitionId: string,
      applicationId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (modelId === null || modelId === undefined) {
      throw new Error("'modelId' parameter required");
    }

    if (tableDefinitionId === null || tableDefinitionId === undefined) {
      throw new Error("'tableDefinitionId' parameter required");
    }

    if (applicationId === null || applicationId === undefined) {
      throw new Error("'applicationId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/${encodeURIComponent(String(modelId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}/${encodeURIComponent(String(applicationId))}`
      .replace('{modelId}', encodeURIComponent(String(modelId)))
      .replace('{tableDefinitionId}', encodeURIComponent(String(tableDefinitionId)))
      .replace('{applicationId}', encodeURIComponent(String(applicationId)));



    return axiosInstance.request({
      method: 'put',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ModelTableApplicationOutputV1>;
  }

  /**
   * @summary Retire a model table application by ID
   * @param {string} applicationId
   * @param {boolean} [deleteColumns=false] - If true, deletes the model-controlled columns from the table definition
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public retireApplication(
    {
      applicationId,
      deleteColumns
    } : {
      applicationId: string,
      deleteColumns?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (applicationId === null || applicationId === undefined) {
      throw new Error("'applicationId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/applications/${encodeURIComponent(String(applicationId))}`
      .replace('{applicationId}', encodeURIComponent(String(applicationId)));

    const queryParams = {
      ['deleteColumns']: deleteColumns
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TableApplicationRetiredOutputV1>;
  }

  /**
   * @summary Retire a model instance by ID
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public retireInstance(
    {
      instanceId
    } : {
      instanceId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (instanceId === null || instanceId === undefined) {
      throw new Error("'instanceId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/models/instances/${encodeURIComponent(String(instanceId))}`
      .replace('{instanceId}', encodeURIComponent(String(instanceId)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.InstanceRetiredOutputV1>;
  }

}


export const sqModelsApi = new sqModelsApiClass();

export type sqModelsApiEndpoints = {
  'applyModel': {
    method: 'post';
    path: '/models/${encodeURIComponent(String(modelId))}/instances';
    response: models.InstanceOutputV1;
  };
  'applyModelToTable': {
    method: 'post';
    path: '/models/${encodeURIComponent(String(modelId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}';
    response: models.ModelTableApplicationOutputV1;
  };
  'archiveModel': {
    method: 'delete';
    path: '/models/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'createDraft': {
    method: 'post';
    path: '/models/${encodeURIComponent(String(modelId))}/drafts';
    response: models.ModelOutputV1;
  };
  'createModel': {
    method: 'post';
    path: '/models';
    response: models.ModelOutputV1;
  };
  'createModelFromItems': {
    method: 'post';
    path: '/models/from-items';
    response: models.ModelOutputV1;
  };
  'createModelFromTableColumnDefinitions': {
    method: 'post';
    path: '/models/from-table-column-definitions';
    response: models.ModelOutputV1;
  };
  'diffModels': {
    method: 'get';
    path: '/models/${encodeURIComponent(String(baseModelId))}/diff/${encodeURIComponent(String(candidateModelId))}';
    response: models.ModelCompatibilityReportOutputV1;
  };
  'duplicateModel': {
    method: 'post';
    path: '/models/${encodeURIComponent(String(modelId))}/duplicate';
    response: models.ModelOutputV1;
  };
  'editModel': {
    method: 'put';
    path: '/models/${encodeURIComponent(String(modelId))}';
    response: models.ModelOutputV1;
  };
  'editModelVersion': {
    method: 'put';
    path: '/models/${encodeURIComponent(String(modelId))}/versions/${encodeURIComponent(String(versionId))}';
    response: models.ModelOutputV1;
  };
  'generateColumnModel': {
    method: 'post';
    path: '/models/modelData';
    response: models.ColumnModelOutput;
  };
  'getAppliedModelTables': {
    method: 'get';
    path: '/models/${encodeURIComponent(String(modelId))}/tables';
    response: Array<models.TableDefinitionOutputV1>;
  };
  'getDraft': {
    method: 'get';
    path: '/models/${encodeURIComponent(String(modelId))}/draft';
    response: models.ModelOutputV1;
  };
  'getInstance': {
    method: 'get';
    path: '/models/instances/${encodeURIComponent(String(instanceId))}';
    response: models.InstanceOutputV1;
  };
  'getInstancesForModel': {
    method: 'get';
    path: '/models/${encodeURIComponent(String(modelId))}/instances';
    response: models.InstanceOutputPaginatedListV1;
  };
  'getInstancesForTable': {
    method: 'get';
    path: '/models/instances/table/${encodeURIComponent(String(tableDefinitionId))}';
    response: models.InstanceOutputPaginatedListV1;
  };
  'getModel': {
    method: 'get';
    path: '/models/${encodeURIComponent(String(modelId))}';
    response: models.ModelOutputV1;
  };
  'getModelVersion': {
    method: 'get';
    path: '/models/${encodeURIComponent(String(modelId))}/versions/${encodeURIComponent(String(versionId))}';
    response: models.ModelOutputV1;
  };
  'getModelVersions': {
    method: 'get';
    path: '/models/${encodeURIComponent(String(modelId))}/versions';
    response: models.ModelVersionListOutputV1;
  };
  'getModels': {
    method: 'get';
    path: '/models';
    response: models.ModelOutputListV1;
  };
  'getTableDefinitionModelApplications': {
    method: 'get';
    path: '/models/${encodeURIComponent(String(id))}/model-applications';
    response: models.ModelTableApplicationsOutputListV1;
  };
  'publishModelVersion': {
    method: 'post';
    path: '/models/${encodeURIComponent(String(modelId))}/versions';
    response: models.StatusMessageBase;
  };
  'reapplyModel': {
    method: 'put';
    path: '/models/${encodeURIComponent(String(modelId))}/instances/${encodeURIComponent(String(instanceId))}';
    response: models.InstanceOutputV1;
  };
  'reapplyModelToTable': {
    method: 'put';
    path: '/models/${encodeURIComponent(String(modelId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}/${encodeURIComponent(String(applicationId))}';
    response: models.ModelTableApplicationOutputV1;
  };
  'retireApplication': {
    method: 'delete';
    path: '/models/applications/${encodeURIComponent(String(applicationId))}';
    response: models.TableApplicationRetiredOutputV1;
  };
  'retireInstance': {
    method: 'delete';
    path: '/models/instances/${encodeURIComponent(String(instanceId))}';
    response: models.InstanceRetiredOutputV1;
  };
};

type ApiApplyModelResponse = models.InstanceOutputV1;
type ApiapplyModelMutationParams = Parameters<typeof sqModelsApi.applyModel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.applyModel>;

export function useApiApplyModelMutation(
  options?: Omit<UseMutationOptions<ApiApplyModelResponse, AxiosError<SeeqErrorData>,
    ApiapplyModelMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiApplyModelResponse, AxiosError<SeeqErrorData>,
  ApiapplyModelMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiapplyModelMutationParams) =>
      sqModelsApi.applyModel(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiApplyModelToTableResponse = models.ModelTableApplicationOutputV1;
type ApiapplyModelToTableMutationParams = Parameters<typeof sqModelsApi.applyModelToTable> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.applyModelToTable>;

export function useApiApplyModelToTableMutation(
  options?: Omit<UseMutationOptions<ApiApplyModelToTableResponse, AxiosError<SeeqErrorData>,
    ApiapplyModelToTableMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiApplyModelToTableResponse, AxiosError<SeeqErrorData>,
  ApiapplyModelToTableMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiapplyModelToTableMutationParams) =>
      sqModelsApi.applyModelToTable(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveModelResponse = models.ArchiveOutputV1;
type ApiarchiveModelMutationParams = Parameters<typeof sqModelsApi.archiveModel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.archiveModel>;

export function useApiArchiveModelMutation(
  options?: Omit<UseMutationOptions<ApiArchiveModelResponse, AxiosError<SeeqErrorData>,
    ApiarchiveModelMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveModelResponse, AxiosError<SeeqErrorData>,
  ApiarchiveModelMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveModelMutationParams) =>
      sqModelsApi.archiveModel(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateDraftResponse = models.ModelOutputV1;
type ApicreateDraftMutationParams = Parameters<typeof sqModelsApi.createDraft> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.createDraft>;

export function useApiCreateDraftMutation(
  options?: Omit<UseMutationOptions<ApiCreateDraftResponse, AxiosError<SeeqErrorData>,
    ApicreateDraftMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateDraftResponse, AxiosError<SeeqErrorData>,
  ApicreateDraftMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateDraftMutationParams) =>
      sqModelsApi.createDraft(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateModelResponse = models.ModelOutputV1;
type ApicreateModelMutationParams = Parameters<typeof sqModelsApi.createModel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.createModel>;
type ApicreateModelMutationVariables = models.ModelInputV1;

export function useApiCreateModelMutation(
  options?: Omit<UseMutationOptions<ApiCreateModelResponse, AxiosError<SeeqErrorData>,
    ApicreateModelMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateModelResponse, AxiosError<SeeqErrorData>,
  ApicreateModelMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateModelMutationVariables) =>
      sqModelsApi.createModel(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateModelFromItemsResponse = models.ModelOutputV1;
type ApicreateModelFromItemsMutationParams = Parameters<typeof sqModelsApi.createModelFromItems> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.createModelFromItems>;
type ApicreateModelFromItemsMutationVariables = models.ModelFromIdsInputV1;

export function useApiCreateModelFromItemsMutation(
  options?: Omit<UseMutationOptions<ApiCreateModelFromItemsResponse, AxiosError<SeeqErrorData>,
    ApicreateModelFromItemsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateModelFromItemsResponse, AxiosError<SeeqErrorData>,
  ApicreateModelFromItemsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateModelFromItemsMutationVariables) =>
      sqModelsApi.createModelFromItems(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateModelFromTableColumnDefinitionsResponse = models.ModelOutputV1;
type ApicreateModelFromTableColumnDefinitionsMutationParams = Parameters<typeof sqModelsApi.createModelFromTableColumnDefinitions> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.createModelFromTableColumnDefinitions>;
type ApicreateModelFromTableColumnDefinitionsMutationVariables = models.ModelFromIdsInputV1;

export function useApiCreateModelFromTableColumnDefinitionsMutation(
  options?: Omit<UseMutationOptions<ApiCreateModelFromTableColumnDefinitionsResponse, AxiosError<SeeqErrorData>,
    ApicreateModelFromTableColumnDefinitionsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateModelFromTableColumnDefinitionsResponse, AxiosError<SeeqErrorData>,
  ApicreateModelFromTableColumnDefinitionsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateModelFromTableColumnDefinitionsMutationVariables) =>
      sqModelsApi.createModelFromTableColumnDefinitions(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDiffModelsResponse = models.ModelCompatibilityReportOutputV1;
export function DiffModelsQueryKey(
  params: Parameters<typeof sqModelsApi.diffModels>[0],
) {
  return ['sqModelsApi', 'diffModels', params] as const;
}

export function useApiDiffModelsQuery(
  params: Parameters<typeof sqModelsApi.diffModels>[0],
  options?: Omit<UseQueryOptions<ApiDiffModelsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiDiffModelsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: DiffModelsQueryKey(params),
    queryFn: () =>
      sqModelsApi.diffModels(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiDuplicateModelResponse = models.ModelOutputV1;
type ApiduplicateModelMutationParams = Parameters<typeof sqModelsApi.duplicateModel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.duplicateModel>;

export function useApiDuplicateModelMutation(
  options?: Omit<UseMutationOptions<ApiDuplicateModelResponse, AxiosError<SeeqErrorData>,
    ApiduplicateModelMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDuplicateModelResponse, AxiosError<SeeqErrorData>,
  ApiduplicateModelMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiduplicateModelMutationParams) =>
      sqModelsApi.duplicateModel(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiEditModelResponse = models.ModelOutputV1;
type ApieditModelMutationParams = Parameters<typeof sqModelsApi.editModel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.editModel>;

export function useApiEditModelMutation(
  options?: Omit<UseMutationOptions<ApiEditModelResponse, AxiosError<SeeqErrorData>,
    ApieditModelMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiEditModelResponse, AxiosError<SeeqErrorData>,
  ApieditModelMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApieditModelMutationParams) =>
      sqModelsApi.editModel(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiEditModelVersionResponse = models.ModelOutputV1;
type ApieditModelVersionMutationParams = Parameters<typeof sqModelsApi.editModelVersion> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.editModelVersion>;

export function useApiEditModelVersionMutation(
  options?: Omit<UseMutationOptions<ApiEditModelVersionResponse, AxiosError<SeeqErrorData>,
    ApieditModelVersionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiEditModelVersionResponse, AxiosError<SeeqErrorData>,
  ApieditModelVersionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApieditModelVersionMutationParams) =>
      sqModelsApi.editModelVersion(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGenerateColumnModelResponse = models.ColumnModelOutput;
type ApigenerateColumnModelMutationParams = Parameters<typeof sqModelsApi.generateColumnModel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.generateColumnModel>;

export function useApiGenerateColumnModelMutation(
  options?: Omit<UseMutationOptions<ApiGenerateColumnModelResponse, AxiosError<SeeqErrorData>,
    ApigenerateColumnModelMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiGenerateColumnModelResponse, AxiosError<SeeqErrorData>,
  ApigenerateColumnModelMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApigenerateColumnModelMutationParams) =>
      sqModelsApi.generateColumnModel(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetAppliedModelTablesResponse = Array<models.TableDefinitionOutputV1>;
export function GetAppliedModelTablesQueryKey(
  params: Parameters<typeof sqModelsApi.getAppliedModelTables>[0],
) {
  return ['sqModelsApi', 'getAppliedModelTables', params] as const;
}

export function useApiGetAppliedModelTablesQuery(
  params: Parameters<typeof sqModelsApi.getAppliedModelTables>[0],
  options?: Omit<UseQueryOptions<ApiGetAppliedModelTablesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAppliedModelTablesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAppliedModelTablesQueryKey(params),
    queryFn: () =>
      sqModelsApi.getAppliedModelTables(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetDraftResponse = models.ModelOutputV1;
export function GetDraftQueryKey(
  params: Parameters<typeof sqModelsApi.getDraft>[0],
) {
  return ['sqModelsApi', 'getDraft', params] as const;
}

export function useApiGetDraftQuery(
  params: Parameters<typeof sqModelsApi.getDraft>[0],
  options?: Omit<UseQueryOptions<ApiGetDraftResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetDraftResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetDraftQueryKey(params),
    queryFn: () =>
      sqModelsApi.getDraft(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetInstanceResponse = models.InstanceOutputV1;
export function GetInstanceQueryKey(
  params: Parameters<typeof sqModelsApi.getInstance>[0],
) {
  return ['sqModelsApi', 'getInstance', params] as const;
}

export function useApiGetInstanceQuery(
  params: Parameters<typeof sqModelsApi.getInstance>[0],
  options?: Omit<UseQueryOptions<ApiGetInstanceResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetInstanceResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetInstanceQueryKey(params),
    queryFn: () =>
      sqModelsApi.getInstance(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetInstancesForModelResponse = models.InstanceOutputPaginatedListV1;
export function GetInstancesForModelQueryKey(
  params: Parameters<typeof sqModelsApi.getInstancesForModel>[0],
) {
  return ['sqModelsApi', 'getInstancesForModel', params] as const;
}

export function useApiGetInstancesForModelQuery(
  params: Parameters<typeof sqModelsApi.getInstancesForModel>[0],
  options?: Omit<UseQueryOptions<ApiGetInstancesForModelResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetInstancesForModelResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetInstancesForModelQueryKey(params),
    queryFn: () =>
      sqModelsApi.getInstancesForModel(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetInstancesForTableResponse = models.InstanceOutputPaginatedListV1;
export function GetInstancesForTableQueryKey(
  params: Parameters<typeof sqModelsApi.getInstancesForTable>[0],
) {
  return ['sqModelsApi', 'getInstancesForTable', params] as const;
}

export function useApiGetInstancesForTableQuery(
  params: Parameters<typeof sqModelsApi.getInstancesForTable>[0],
  options?: Omit<UseQueryOptions<ApiGetInstancesForTableResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetInstancesForTableResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetInstancesForTableQueryKey(params),
    queryFn: () =>
      sqModelsApi.getInstancesForTable(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetModelResponse = models.ModelOutputV1;
export function GetModelQueryKey(
  params: Parameters<typeof sqModelsApi.getModel>[0],
) {
  return ['sqModelsApi', 'getModel', params] as const;
}

export function useApiGetModelQuery(
  params: Parameters<typeof sqModelsApi.getModel>[0],
  options?: Omit<UseQueryOptions<ApiGetModelResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetModelResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetModelQueryKey(params),
    queryFn: () =>
      sqModelsApi.getModel(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetModelVersionResponse = models.ModelOutputV1;
export function GetModelVersionQueryKey(
  params: Parameters<typeof sqModelsApi.getModelVersion>[0],
) {
  return ['sqModelsApi', 'getModelVersion', params] as const;
}

export function useApiGetModelVersionQuery(
  params: Parameters<typeof sqModelsApi.getModelVersion>[0],
  options?: Omit<UseQueryOptions<ApiGetModelVersionResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetModelVersionResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetModelVersionQueryKey(params),
    queryFn: () =>
      sqModelsApi.getModelVersion(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetModelVersionsResponse = models.ModelVersionListOutputV1;
export function GetModelVersionsQueryKey(
  params: Parameters<typeof sqModelsApi.getModelVersions>[0],
) {
  return ['sqModelsApi', 'getModelVersions', params] as const;
}

export function useApiGetModelVersionsQuery(
  params: Parameters<typeof sqModelsApi.getModelVersions>[0],
  options?: Omit<UseQueryOptions<ApiGetModelVersionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetModelVersionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetModelVersionsQueryKey(params),
    queryFn: () =>
      sqModelsApi.getModelVersions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetModelsResponse = models.ModelOutputListV1;
export function GetModelsQueryKey(
  params: Parameters<typeof sqModelsApi.getModels>[0],
) {
  return ['sqModelsApi', 'getModels', params] as const;
}

export function useApiGetModelsQuery(
  params: Parameters<typeof sqModelsApi.getModels>[0],
  options?: Omit<UseQueryOptions<ApiGetModelsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetModelsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetModelsQueryKey(params),
    queryFn: () =>
      sqModelsApi.getModels(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetTableDefinitionModelApplicationsResponse = models.ModelTableApplicationsOutputListV1;
export function GetTableDefinitionModelApplicationsQueryKey(
  params: Parameters<typeof sqModelsApi.getTableDefinitionModelApplications>[0],
) {
  return ['sqModelsApi', 'getTableDefinitionModelApplications', params] as const;
}

export function useApiGetTableDefinitionModelApplicationsQuery(
  params: Parameters<typeof sqModelsApi.getTableDefinitionModelApplications>[0],
  options?: Omit<UseQueryOptions<ApiGetTableDefinitionModelApplicationsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTableDefinitionModelApplicationsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTableDefinitionModelApplicationsQueryKey(params),
    queryFn: () =>
      sqModelsApi.getTableDefinitionModelApplications(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiPublishModelVersionResponse = models.StatusMessageBase;
type ApipublishModelVersionMutationParams = Parameters<typeof sqModelsApi.publishModelVersion> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.publishModelVersion>;

export function useApiPublishModelVersionMutation(
  options?: Omit<UseMutationOptions<ApiPublishModelVersionResponse, AxiosError<SeeqErrorData>,
    ApipublishModelVersionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPublishModelVersionResponse, AxiosError<SeeqErrorData>,
  ApipublishModelVersionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApipublishModelVersionMutationParams) =>
      sqModelsApi.publishModelVersion(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiReapplyModelResponse = models.InstanceOutputV1;
type ApireapplyModelMutationParams = Parameters<typeof sqModelsApi.reapplyModel> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.reapplyModel>;

export function useApiReapplyModelMutation(
  options?: Omit<UseMutationOptions<ApiReapplyModelResponse, AxiosError<SeeqErrorData>,
    ApireapplyModelMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiReapplyModelResponse, AxiosError<SeeqErrorData>,
  ApireapplyModelMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApireapplyModelMutationParams) =>
      sqModelsApi.reapplyModel(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiReapplyModelToTableResponse = models.ModelTableApplicationOutputV1;
type ApireapplyModelToTableMutationParams = Parameters<typeof sqModelsApi.reapplyModelToTable> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.reapplyModelToTable>;

export function useApiReapplyModelToTableMutation(
  options?: Omit<UseMutationOptions<ApiReapplyModelToTableResponse, AxiosError<SeeqErrorData>,
    ApireapplyModelToTableMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiReapplyModelToTableResponse, AxiosError<SeeqErrorData>,
  ApireapplyModelToTableMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApireapplyModelToTableMutationParams) =>
      sqModelsApi.reapplyModelToTable(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRetireApplicationResponse = models.TableApplicationRetiredOutputV1;
type ApiretireApplicationMutationParams = Parameters<typeof sqModelsApi.retireApplication> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.retireApplication>;

export function useApiRetireApplicationMutation(
  options?: Omit<UseMutationOptions<ApiRetireApplicationResponse, AxiosError<SeeqErrorData>,
    ApiretireApplicationMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRetireApplicationResponse, AxiosError<SeeqErrorData>,
  ApiretireApplicationMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiretireApplicationMutationParams) =>
      sqModelsApi.retireApplication(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRetireInstanceResponse = models.InstanceRetiredOutputV1;
type ApiretireInstanceMutationParams = Parameters<typeof sqModelsApi.retireInstance> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqModelsApi.retireInstance>;

export function useApiRetireInstanceMutation(
  options?: Omit<UseMutationOptions<ApiRetireInstanceResponse, AxiosError<SeeqErrorData>,
    ApiretireInstanceMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRetireInstanceResponse, AxiosError<SeeqErrorData>,
  ApiretireInstanceMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiretireInstanceMutationParams) =>
      sqModelsApi.retireInstance(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
